import NotificationsTabContent from '../NotificationsTabContent';

/**
 * Notifications Machines
 */
const NotificationsMachines = () => <NotificationsTabContent category="machines" />;

export default NotificationsMachines;
